/* eslint-disable */
import services from 'services';
import mixpanel from '@/vendors/mixpanel/mixpanel';
import * as types from './mutation-types';
import User from '@/entities/User';

export default {
  loginWithUserToken: async ({ commit, dispatch, rootGetters }, { user, userToken }) => {
    const alreadyLoggedInBefore = rootGetters['auth/currentUserId'];
    const shop = rootGetters['shopAuth/currentShop'];
    if (!alreadyLoggedInBefore) {
      console.log(user);
      mixpanel.identify(user.uid);
      mixpanel.people.set({
        $email: user.email,
        $name: user.displayName,
        uid: user.uid,
      });
      if (shop && shop.shopEmail && shop.shopId) {
        console.log('SET', shop);
        mixpanel.people.set({
          emailMagasin: shop.shopEmail,
          idMagasin: shop.shopId,
        });
      }
    }
    commit(types.LOGIN, { user: user, userToken: userToken });
  },
  /**
  * Adds user to state and set state.authenticated value to true
  */
  loginWithCredentials: async ({ commit, dispatch, rootGetters }, { username, password }) => {
    const userToken = await services.authService.loginWithCredentials(username, password);
    const user = await services.authService.getUserByUid(userToken.uid);
    dispatch('loginWithUserToken', {user, userToken});
  },
  /**
   * This action is used by vue-common-ui to login users from admin-outils-mag
   */
  loginWithCustomToken: async ({ commit, dispatch }, userToken) => {
    console.log('login with custom token', userToken);
    const { user } = await services.authService.loginWithCustomToken(userToken);
    console.log('USER', user);
    dispatch('loginUser', user);
    dispatch('fetchCurrentUserProfile');
  },
  loginUser: async ({ commit, rootGetters }, user) => {
    const alreadyLoggedInBefore = rootGetters['auth/currentUserId'];
    const shop = rootGetters['$hbui/shopAuth/currentShop'];
    console.log('LOGIN USER', user);
    if (!alreadyLoggedInBefore) {
      mixpanel.identify(user.uid);
      mixpanel.people.set({
        $email: user.email,
        $name: user.displayName,
        uid: user.uid,
      });
      if (shop && shop.shopEmail && shop.shopId) {
        mixpanel.people.set({
          emailMagasin: shop.shopEmail,
          idMagasin: shop.shopId,
        });
      }
    }
    commit(types.LOGIN, { user });
  },
  /**
  * Removes user from state and reset state.authenticated
  */
  logout: ({ commit, dispatch }) => {
    return services.authService.logout().then(() => {
      commit(types.LOGOUT);
    });
  },
  /**
  * Replaces state.user by firebase.auth().currentUser
  */
  updateUser: async ({ commit, getters, dispatch }) => {
    const user = await dispatch('fetchCurrentUserProfile');
    let authenticated = false;
    if (user) {
      authenticated = true;
    }
    commit(types.UPDATE_USER, { user, authenticated });
  },
  fetchCurrentUserProfile: async ({ commit, getters, rootGetters }, userId) => {
    let currentUserId = userId;
    if (!currentUserId) {
      currentUserId = getters['currentUserId'];
    }

    console.log('CURRENT USERID', currentUserId);
    const customClaims = await services.authService.getCurrentCustomTokenUserInfo(currentUserId);
    if (customClaims) {
      const profile = new User(customClaims);
      profile.shopId = rootGetters["$hbui/shopAuth/currentShopId"];
      profile.status = 'active';
      console.log('SET_PROFILE', profile);
      commit('SET_USER_PROFILE', profile);
      return profile;
    }
    const profile = await services.authService.getUserByUid(currentUserId);
    console.log('SET_PROFILE2', profile);
    commit('SET_USER_PROFILE', profile);
    return profile;
  },

  GetAllUsers: async ({ commit }) => {
    const users = await services.authService.getUsersFromShop();
    commit(types.GET_USERS, users);
  },

  checkUserGuide: async ({ commit }) => {
    const userGuide = await services.authService.checkUserGuide();
    console.log('userGuide');
    console.log(userGuide);
    commit(types.SET_USER_GUIDE, userGuide);
  },

  setUserGuide: async ({ commit }) => {
    const userGuide = await services.authService.setUserGuide();
    commit(types.SET_USER_GUIDE, true);
  },
};
